import { Box, Typography } from '@mui/material';

export const MobileSectionDetail = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        marginBottom: '16px',
        overflow: 'hidden',
        border: '0.667px solid #C4C6D0',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
        minWidth: '320px',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#D9D9E0',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '16px',
        }}
      >
        <Typography
          sx={{
            color: '#1A1C20',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0.1px',
            fontFamily: '"Noto Sans JP", sans-serif',
          }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  );
};
